import { milliseconds, seconds } from '~/interfaces';
import { formatSongLength } from '~/modules/songs/utils/format-song-length';

// Floored rather than rounded, so the two ends never add up to a second more than the song.
export const atSecond = (ms: milliseconds) => formatSongLength(Math.floor(Math.max(0, ms) / 1000)) ?? '0:00';

export const formatSongPosition = (currentTime: milliseconds, duration: seconds): string | undefined => {
  // Dropped rather than zeroed: the duration comes from the video player, so it is 0 until the video
  // has loaded, and "1:49 of 0:00" reads as a broken song rather than as a length nobody knows yet.
  if (!duration || !Number.isFinite(duration)) return undefined;

  const durationMs = duration * 1000;

  // Clamped: the video runs on past the last note, and an outro long enough to pause in would
  // otherwise put the position past the end of the song.
  return `${atSecond(Math.min(currentTime, durationMs))} of ${atSecond(durationMs)}`;
};
